import _axios from "@/axios";
import { reactive } from "@vue/composition-api";

export function useHomePage() {
  const homepageData = reactive({
    isLoading: false,
  });
  function getHomeData(onSuccess, onFailure) {
    homepageData.isLoading = true;

    return _axios
      .get("/homepage")
      .then((response) => {
        onSuccess(response.data.data);
        homepageData.isLoading = false;
      })
      .catch((error) => {
        if (error && error.response) onFailure(error.response.data.violations);
        else console.error(error);
      });
  }

  return {
    getHomeData,
    homepageData,
  };
}
